import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import classNames from 'classnames';
import styles from './Footer.module.scss';

type FooterProps = {
  classNameModifier?: string;
  children: React.ReactNode;
  /**
   * Adds extra padding to the bottom of the footer on mobile.
   * Example usage: pages where BottomSheet is used and the footer content should be "pushed up"
   */
  extraBottomPaddingMobile?: boolean;
};

const Footer: FC<FooterProps> = ({
  children,
  classNameModifier = '',
  extraBottomPaddingMobile = false,
}) => {
  const { isMobileNativeWebView } = useMobileNativeWebView();

  // If user is in mobile app web view, don't render the Footer
  if (isMobileNativeWebView) return null;

  return (
    <section className={getClassNames(styles, 'root', classNames(classNameModifier, { extraBottomPaddingMobile }))}>
      {children}
    </section>
  );
};

export default Footer;
